module.exports = __webpack_public_path__ + "static/media/show_solution_icon.823ff26d.png";